export default "__VITE_ASSET__BhUFem5T__"